import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vue3GoogleLogin from 'vue3-google-login'
import store from './store'


createApp(App)
.use(router)
.use(store)
.use(vue3GoogleLogin, {
    'clientId': '685644182725-r2q803a2g90ruelmjfpg49ldpdq0637f.apps.googleusercontent.com',
})
.mount('#app')
